document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("m-visitors-counter").forEach(function (counter) {
    const min = parseInt(counter.dataset.liveViewsMin);
    const max = parseInt(counter.dataset.liveViewsMax);
    const duration = parseInt(counter.dataset.liveViewsDuration) || 5000;

    function randomViews() {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function updateViews() {
      const current = randomViews();
      const textEl = counter.querySelector(".live-views-text");
      if (textEl) {
        textEl.innerHTML = textEl.innerHTML.replace(/\d+/, current);
      }
    }

    updateViews();
    setInterval(updateViews, duration);
  });
});
